import Client from './client';

export default class SmpTaxCalculationForms extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  post(organization, reference, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/quotes/${reference}/tax/calculation`, {
      ...options,
       method: 'POST',
    });
  }

}
